import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopHeader from "./TopHeader";
import "./AdminLayout.css";

function AdminLayout() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  // ✅ Check Admin/Developer Role
  useEffect(() => {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("access_token");

  

    if (!token || !role) {
      console.log("❌ No token/role - redirecting to login");
      navigate("/Admin_Login");
      return;
    }

    // ✅ FIXED - Allow admin, superadmin, AND developer
    const allowedRoles = ["admin", "superadmin", "developer", "dev"];
    const roleLower = role.toLowerCase();

    if (!allowedRoles.includes(roleLower)) {
      console.log(`❌ Role "${roleLower}" not allowed - redirecting`);
      navigate("/Admin_Login");
    } else {
      console.log(`✅ Role "${roleLower}" allowed - access granted`);
    }
  }, [navigate]);

  // ✅ Handle Responsive
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      if (mobile) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} isMobile={isMobile} onClose={() => setIsSidebarOpen(false)} />

      {/* Overlay for Mobile */}
      {isMobile && isSidebarOpen && (
        <div className="admin-overlay" onClick={() => setIsSidebarOpen(false)} />
      )}

      {/* Main Content Area */}
      <div className={`admin-main ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
        {/* Top Header */}
        <TopHeader onToggleSidebar={toggleSidebar} />

        {/* Page Content */}
        <div className="admin-content">
          <Outlet />
        </div>

        {/* Footer */}
        <div className="admin-footer">
          © 2025 Matrimonial. All rights reserved. <span style={{ color: "#ff0055" }}>💖</span>
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;